export const SEBRAE = 'Sebrae';
export const REPRESENTATIVE = 'Representante';
export const COLLABORATOR = 'Colaborador';

export default { SEBRAE, REPRESENTATIVE, COLLABORATOR };
